import React from 'react';
import './BigHeader.css'
function BigHeader({ headerText, backgroundImage }) {
  const headerStyle = {
    backgroundImage: `url(${backgroundImage})`,
  };

  return (
    <div className="big-header" style={headerStyle}>
      <h1>{headerText}</h1>
    </div>
  );
}

export default BigHeader;
